import TabStack from '@/components/Navigation/TabStack';

export const unstable_settings = {
  initialRouteName: 'index',
};

export default function PrivateTabsEventLayoutRoute() {
  return <TabStack />;
}
